"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CXTupleI18nDomainMappingV2ClientImpl = /** @class */ (function () {
    function CXTupleI18nDomainMappingV2ClientImpl(configSet) {
        this.configSet = configSet;
    }
    CXTupleI18nDomainMappingV2ClientImpl.prototype.getI18nDomain = function (context, weblabContext) {
        return this.configSet.getString("i18n_domain", context === null || context === void 0 ? void 0 : context.toRawContext(), weblabContext);
    };
    return CXTupleI18nDomainMappingV2ClientImpl;
}());
exports.default = CXTupleI18nDomainMappingV2ClientImpl;
